const { performance } = window;

/**
 * sanitizes the url
 * @param {string} url url
 */
// replaces /apis/ with api- only if it’s NOT preceded by /cotton
const sanitizeUrl = url => (
  url.replace(/(\d+([-_]?\d+)+)/g, '*')
     .replace(/(?<!\/cotton)\/apis\//, 'api-')
);

const LogHelperFactory = log => (request) => {
  const startTime = performance.now();
  const {
    options: { method } = {},
    page,
    url,
  } = request;
  const send = (event = 'metrics', data) => {
    log(event, {
      ...data,
      startTime,
      duration: performance.now() - startTime,
      method,
      page,
      url: sanitizeUrl(url),
    });
  };
  return {
    /**
     * checks to see if response has already been marked for this page,
     * if not mark the response
     * @param {object} response response object
     */
    logResponse(response = {}) {
      const { status } = response;
      send('ajax_response', { status });
    },
    /**
     * log the response error
     * @params {object} error object
     * @return {object} response
     */
    logError(error = {}) {
      const { name, message, status } = error;
      send('ajax_response_error', {
        name,
        message,
        error,
        status,
      });
    },
  };
};

export default LogHelperFactory;
